import React, { useState } from 'react';
import NextLink from 'next/link';
import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { cx } from 'class-variance-authority';
import { Collapse } from '@dapp/multi-lib/sdaoui/Collapse';
import * as Menu from 'structure/Layouts/LayoutWithSideBar/menu';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';
import { twMerge } from 'tailwind-merge';

type MenuItemProps = Omit<Menu.MenuItem, 'items' | 'icon'> & {
  icon: React.ReactNode;
  active?: boolean;
  children?: React.ReactNode;
  endEnhancer?: React.ReactNode;
};

export const MenuItem = (props: MenuItemProps) => {
  const { icon, label, children, href, target, active, endEnhancer } = props;
  const [expandChild, setExpandChild] = useState(true);

  const hasChild = children && React.Children.count(children) > 0;

  const handleClickExpandChild = () => {
    if (hasChild) {
      setExpandChild((prev) => !prev);
    }
  };

  const NavWrapper = !hasChild && href ? NextLink : 'div';

  return (
    <div className='flex w-full flex-col'>
      <div
        className={twMerge(
          cx(
            'text-[#A0ABBE]',
            active && hasChild ? 'gradient-box-cosmos' : undefined,
            active && !hasChild ? 'text-[#CCA4FF]' : undefined
          ) as string
        )}
      >
        <NavWrapper
          href={href ?? ''}
          target={target}
          className='flex flex-row items-center gap-2.5 py-1.5 pl-2.5 pr-2'
          onClick={handleClickExpandChild}
        >
          {icon}
          <Typography className='whitespace-nowrap text-sm font-bold text-inherit'>
            {label}
          </Typography>
          {endEnhancer && endEnhancer}
          {hasChild && (
            <div
              className={cx(
                'ml-auto transition-all duration-300 ease-in-out',
                expandChild ? '-rotate-180' : 'rotate-0'
              )}
            >
              <Icon
                icon='arrow_drop_up'
                width={24}
                height={24}
                color='#C1CAD6'
              />
            </div>
          )}
        </NavWrapper>
      </div>
      {hasChild && (
        <Collapse visible={expandChild} type='vertical'>
          {React.Children.map(children, (child) => child)}
        </Collapse>
      )}
    </div>
  );
};
